import { ApiError } from '../../api/types';
import { UserContactViewModel } from '../../model/profile/types';
import { LoadMembershipsFailedAction, LoadMembershipsStartedAction, LoadMembershipsSuccededAction } from '../memberships/types';

export const REGISTER_LMS_USER_STARTED = 'REGISTER_LMS_USER_STARTED';
export const REGISTER_LMS_USER_SUCCEEDED = 'REGISTER_LMS_USER_SUCCEEDED';
export const REGISTER_LMS_USER_FAILED = 'REGISTER_LMS_USER_FAILED';
export const LOADING_USERPROFILE_STARTED = 'LOADING_USERPROFILE_STARTED';
export const LOAD_USERPROFILE_SUCCEEDED  = 'LOAD_USERPROFILE_SUCCEEDED';
export const LOAD_USERPROFILE_FAILED = 'LOAD_USERPROFILE_FAILED';
export const VERIFY_LMS_USER_STARTED = 'VERIFY_LMS_USER_STARTED';
export const VERIFY_LMS_USER_FAILED = 'VERIFY_LMS_USER_FAILED';
export const VERIFY_LMS_USER_SUCCEEDED = 'VERIFY_LMS_USER_SUCCEEDED';
export const ARE_SEATS_AVAILABLE_STARTED = 'ARE_SEATS_AVAILABLE_STARTED';
export const ARE_SEATS_AVAILABLE_FAILED = 'ARE_SEATS_AVAILABLE_FAILED';
export const ARE_SEATS_AVAILABLE_SUCCEEDED = 'ARE_SEATS_AVAILABLE_SUCCEEDED';
export const RETRIEVE_DECRYPTED_ORDER_STARTED = 'RETRIEVE_DECRYPTED_ORDER_STARTED';
export const RETRIEVE_DECRYPTED_ORDER_FAILED = 'RETRIEVE_DECRYPTED_ORDER_FAILED';
export const RETRIEVE_DECRYPTED_ORDER_SUCCEEDED = 'RETRIEVE_DECRYPTED_ORDER_SUCCEEDED';
export const RETRIEVE_DECRYPTED_PROFILE_STARTED = 'RETRIEVE_DECRYPTED_PROFILE_STARTED';
export const RETRIEVE_DECRYPTED_PROFILE_FAILED = 'RETRIEVE_DECRYPTED_PROFILE_FAILED';
export const RETRIEVE_DECRYPTED_PROFILE_SUCCEEDED = 'RETRIEVE_DECRYPTED_PROFILE_SUCCEEDED';
export const RETRIEVE_ENCRYPTED_PROFILE_STARTED = 'RETRIEVE_ENCRYPTED_PROFILE_STARTED';
export const RETRIEVE_ENCRYPTED_PROFILE_FAILED = 'RETRIEVE_ENCRYPTED_PROFILE_FAILED';
export const RETRIEVE_ENCRYPTED_PROFILE_SUCCEEDED = 'RETRIEVE_ENCRYPTED_PROFILE_SUCCEEDED';


export interface VerifyLMSUserViewModel {
  verificationData: NewUserVerificationModel;
  verifyLMSUserResult: VerifyLmsUserResult;
}


export interface SelfRegistrationModel {
  error: string;
  orderNumber: string;
  profileId: string;
  userProfileExists: boolean;
  userLMSProfileSavedResult: RegisterLMSUserResult;
  areSeatsAvailableResult: AreSeatsAvailableResult;
  userProfileData: LMSUserViewModel;
  verifyLMSUserData: VerifyLMSUserViewModel;
  memberships: string[];
  loading: boolean;
}

export interface LMSUserViewModel {
  email: string;
  firstName: string;
  lastName: string;
  title: string;
  organizationname: string;
  department: string;
  address: string;
  city: string;
  stateorProvince: string;
  country: string;
  postalCode: string;
  phone: string;
  addressType?: number;
  sourceUrl: string;
  error?: ApiError;
  crmGuid: string;
  subscriptions : string[];
  activated: boolean;
}

export interface NewUserVerificationModel{
  memberships: string[];
  orderNumber: string | null;
  password: string;
  profileId: string;
  error?: ApiError;
}

export interface LmsUserProfile
{
  subscriptions: string[];
  userName: string;
}

export interface VerifyLmsUserResult
{
    userProfile: LmsUserProfile;
    message: string;
    success: boolean;
}

export interface VerifyLMSUserStartedAction {
  type: typeof VERIFY_LMS_USER_STARTED;
  payload: string;
}

export interface VerifyLMSUserSucceededAction {
  type: typeof VERIFY_LMS_USER_SUCCEEDED;
  payload: VerifyLMSUserViewModel;
}

export interface VerifyLMSUserFailedAction {
  type: typeof VERIFY_LMS_USER_FAILED;
  payload: string;
}

export interface AreSeatsAvailableStartedAction {
  type: typeof ARE_SEATS_AVAILABLE_STARTED;
  payload: string;
}

export interface AreSeatsAvailableSucceededAction {
  type: typeof ARE_SEATS_AVAILABLE_SUCCEEDED;
  payload: AreSeatsAvailableResult;
}

export interface AreSeatsAvailableFailedAction {
  type: typeof ARE_SEATS_AVAILABLE_FAILED;
  payload: string;
}


export interface AreSeatsAvailableResult{
  message: string;
  success: boolean;
}

export interface AreSeatsAvailableModel {
  facilityId: string | null;
  memberships: string[];
  orderNumber: string;
}

export interface LoadingUserProfileAction {
  type: typeof LOADING_USERPROFILE_STARTED;
  payload: string[];
}
export interface LoadUserProfileFailedAction {
  type: typeof LOAD_USERPROFILE_FAILED;
  payload: string;
}
export interface LoadUserProfileSucceededAction {
  type: typeof LOAD_USERPROFILE_SUCCEEDED;
  payload: UserContactViewModel;
}

export interface RegisterLMSUserStartedAction {
  type: typeof REGISTER_LMS_USER_STARTED;
  payload: string;
}

export interface RegisterLMSUserSucceededAction {
  type: typeof REGISTER_LMS_USER_SUCCEEDED;
  payload: string;
}

export interface RegisterLMSUserFailedAction {
  type: typeof REGISTER_LMS_USER_FAILED;
  payload: string;
}
export interface RegisterLMSUserResult{
  message: string;
  success: boolean;
}

export interface RetrieveDecryptedOrderStartedAction{
  type: typeof RETRIEVE_DECRYPTED_ORDER_STARTED;
  payload: string;
}

export interface RetrieveDecryptedOrderSucceededAction{
  type: typeof RETRIEVE_DECRYPTED_ORDER_SUCCEEDED;
  payload: string;
}

export interface RetrieveDecryptedOrderFailedAction{
  type: typeof RETRIEVE_DECRYPTED_ORDER_FAILED;
  payload: string;
}

export interface RetrieveDecryptedProfileStartedAction{
  type: typeof RETRIEVE_DECRYPTED_PROFILE_STARTED;
  payload: string;
}

export interface RetrieveDecryptedProfileSucceededAction{
  type: typeof RETRIEVE_DECRYPTED_PROFILE_SUCCEEDED;
  payload: string;
}

export interface RetrieveDecryptedProfileFailedAction{
  type: typeof RETRIEVE_DECRYPTED_PROFILE_FAILED;
  payload: string;
}

export interface RetrieveEncryptedProfileStartedAction{
  type: typeof RETRIEVE_ENCRYPTED_PROFILE_STARTED;
  payload: string;
}

export interface RetrieveEncryptedProfileSucceededAction{
  type: typeof RETRIEVE_ENCRYPTED_PROFILE_SUCCEEDED;
  payload: string;
}

export interface RetrieveEncryptedProfileFailedAction{
  type: typeof RETRIEVE_ENCRYPTED_PROFILE_FAILED;
  payload: string;
}

export type SelfRegistrationActionTypes =
  | RegisterLMSUserStartedAction
  | RegisterLMSUserSucceededAction
  | RegisterLMSUserFailedAction
  | LoadingUserProfileAction
  | LoadUserProfileFailedAction
  | LoadUserProfileSucceededAction
  | VerifyLMSUserStartedAction
  | VerifyLMSUserSucceededAction
  | VerifyLMSUserFailedAction
  | AreSeatsAvailableStartedAction
  | AreSeatsAvailableSucceededAction
  | AreSeatsAvailableFailedAction
  | LoadMembershipsFailedAction
  | LoadMembershipsStartedAction
  | LoadMembershipsSuccededAction
  | RetrieveDecryptedOrderStartedAction
  | RetrieveDecryptedOrderSucceededAction
  | RetrieveDecryptedOrderFailedAction
  | RetrieveDecryptedProfileStartedAction
  | RetrieveDecryptedProfileSucceededAction
  | RetrieveDecryptedProfileFailedAction
  | RetrieveEncryptedProfileStartedAction
  | RetrieveEncryptedProfileSucceededAction
  | RetrieveEncryptedProfileFailedAction
